import { Link } from "react-router-dom";
import { allCategories, allTopics } from "@/utils/data";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-leaf-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">自慰</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/80">
              自慰网站是一个面向成人的健康生活资讯平台，致力于用科学、温和的方式，帮助你了解身体与心理，建立积极的自我关怀态度。
            </p>
            <p className="mt-4 text-xs text-primary-200/70">
              本站内容仅供健康科普参考，不能替代专业医疗建议。如需诊疗，请咨询专业医生。
            </p>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-background-50 mb-4">资讯分类</h2>
            <ul className="space-y-2.5">
              {allCategories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-sm text-primary-100/80 hover:text-background-50 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-background-50 mb-4">精选专题</h2>
            <ul className="space-y-2.5">
              {allTopics.map((topic) => (
                <li key={topic.id}>
                  <Link
                    to={`/topic/${topic.id}`}
                    className="text-sm text-primary-100/80 hover:text-background-50 transition-colors"
                  >
                    {topic.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-background-50 mb-4">关于与帮助</h2>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-primary-100/80 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-primary-100/80 hover:text-background-50 transition-colors">
                  联系反馈
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-primary-100/80 hover:text-background-50 transition-colors">
                  站内搜索
                </Link>
              </li>
            </ul>
            <div className="mt-6 flex items-center gap-2 text-xs text-primary-200/70">
              <i className="ri-shield-check-line text-accent-400"></i>
              内容面向 18 岁以上成年人
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-200/70">
            © {new Date().getFullYear()} 自慰 · 健康生活资讯站 保留所有权利
          </p>
          <p className="text-xs text-primary-200/70">
            本站为健康科普资讯平台，收藏与阅读记录保存在您的浏览器本地。
          </p>
        </div>
      </div>
    </footer>
  );
}